<template>
	<svg
		data-testid="atom-checkmark-animation"
		class="atom-checkmark-animation"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 52 52"
	>
		<circle
			class="atom-checkmark-animation__circle"
			cx="26"
			cy="26"
			r="25"
			fill="none"
		/>
		<path
			class="atom-checkmark-animation__check"
			fill="none"
			d="M14.1 27.2l7.1 7.2 16.7-16.8"
		/>
	</svg>
</template>

<script setup lang="ts">
</script>

<style lang="postcss" scoped>
.atom-checkmark-animation {
    @apply size-24 shadow-[inset_0px_0px_0px_0px] shadow-green-600 stroke-white;

    border-radius: 50%;
    display: block;
    stroke-width: 2;
    stroke-miterlimit: 10;
    animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;

    .atom-checkmark-animation__circle {
        @apply stroke-green-600;

        stroke-dasharray: 166;
        stroke-dashoffset: 166;
        stroke-width: 2;
        stroke-miterlimit: 10;
        fill: none;
        animation: stroke .6s cubic-bezier(0.650, 0.000, 0.450, 1.000) forwards;
    }

    .atom-checkmark-animation__check {
        transform-origin: 50% 50%;
        stroke-dasharray: 48;
        stroke-dashoffset: 48;
        animation: stroke .3s cubic-bezier(0.650, 0.000, 0.450, 1.000) .8s forwards;
    }
}

@keyframes stroke {
    100% {
        stroke-dashoffset: 0;
    }
}

@keyframes scale {
    0%, 100% {
        transform: none;
    }
    50% {
        transform: scale3d(1.1, 1.1, 1);
    }
}

@keyframes fill {

    100% {
        @apply shadow-[inset_0px_0px_0px_30px] shadow-green-600;
    }
}
</style>
